export const LegalCaseTypeState = _ => ({
  selectedLegalCaseTypes: [],
})
